<template>
  <div class="cyq-activity">
    <div class="lqjf-container">
      <img class="lqjf-img" src="/static/images/cyq/lqjf.png" alt="lqjf">
      <div v-if="showSuccess" class="congrats-text">
        <div class="congrats-title">恭喜获得</div>
        <div class="congrats-points">{{ points }}积分</div>
      </div>
      <div v-if="isPointsClaimed" class="points-claimed">积分已被领取</div>
      <wx-open-launch-weapp 
        class="qwsc-img"
        :appid="miniAppId" 
        :username="miniAppOriginalId" 
        :path="miniAppPage"> 
        <script type="text/wxtag-template"> 
          <img src="https://zishu-image.oss-cn-shanghai.aliyuncs.com/qwsc-2dc5ddcb31e74dedae22d278a84aefd0.png" style="width: 100%;height: auto;display: block;" /> 
        </script> 
      </wx-open-launch-weapp>
    </div>
    <img class="bg-img" src="/static/images/cyq/bg.png" alt="bg">
  </div>
</template>

<script>
import { getJSSDK, getScoreConfig, getTemplate, registerByOpenId, joinActivity } from '../../api/api'
import wx from 'weixin-js-sdk'

export default {
  name: 'CyqActivity',
  data() {
    return {
      appId: process.env.ENV_NUM === '1' ? 'wxb576b8e7ccb1ad66' : 'wxbc22565b3e7a59fd',
      eno: process.env.ENV_NUM === '1' ? '138548738944' : '138495952793',
      code: '',
      deptId: '',
      wyAuthCode: '',
      activityId: '',
      activityRule: '',
      shopUrl: '',
      miniAppId: '',
      miniAppOriginalId: '',
      miniAppPage: '',
      token: '',
      points: '',
      isPointsClaimed: false,
      showSuccess: false
    }
  },
  async mounted() {
    await this.getWxJs()
    if (this.$route.query.c) {
      this.code = this.$route.query.c
    }
    if (this.$route.query.deptId) {
      this.deptId = this.$route.query.deptId
    }
    if (this.$route.query.wyAuthCode) {
      this.wyAuthCode = this.$route.query.wyAuthCode
    }
    await this.getScoreConfig()
    await this.getTemplate()
  },
  methods: {
    getWxJs() {
      const url = encodeURIComponent(window.location.href.split('#')[0])
      return getJSSDK(url, this.appId).then(res => {
        const data = res.data.data
        wx.config({
          debug: false,
          appId: data.appId,
          timestamp: data.timestamp,
          nonceStr: data.nonceStr,
          signature: data.signature,
          openTagList: ["wx-open-launch-weapp", "wx-open-launch-app"],
          jsApiList: [
            'checkJsApi',
            'onMenuShareTimeline',
            'onMenuShareAppMessage',
            'onMenuShareQQ',
            'onMenuShareWeibo',
            'onMenuShareQZone',
            'hideMenuItems',
            'showMenuItems',
            'hideAllNonBaseMenuItem',
            'showAllNonBaseMenuItem',
            'translateVoice',
            'startRecord',
            'stopRecord',
            'onVoiceRecordEnd',
            'playVoice',
            'onVoicePlayEnd',
            'pauseVoice',
            'stopVoice',
            'uploadVoice',
            'downloadVoice',
            'chooseimg',
            'predivimg',
            'uploadimg',
            'downloadimg',
            'getNetworkType',
            'openLocation',
            'getLocation',
            'hideOptionMenu',
            'showOptionMenu',
            'closeWindow',
            'scanQRCode',
            'chooseWXPay',
            'openProductSpecificdiv',
            'addCard',
            'chooseCard',
            'openCard'
          ]
        });
        wx.ready(function () {
          wx.hideMenuItems({
            menuList: [
              'menuItem:copyUrl',
              'menuItem:openWithQQBrowse',
              'menuItem:openWithSafari',
              'menuItem:email',
              'menuItem:readMode',
              'menuItem:originPage',
              'menuItem:delete',
              'menuItem:editTag'
            ]
          });
        });
      }).catch(err =>
        alert("获取微信授权失败" + err)
      )
    },
    async getScoreConfig() {
      getScoreConfig(this.deptId).then(res => {
        if (res.data && res.data.data) {
          this.shopUrl = res.data.data.shopUrl
          const data = this.shopUrl.split('|')
          this.miniAppId = data[0]
          this.miniAppOriginalId = data[1]
          this.miniAppPage = data[2]
        }
      })
    },
    async getTemplate() {
      getTemplate(this.deptId).then(res => {
        if (res.data && res.data.data) {
          this.activityId = res.data.data.activityId
          this.activityRule = res.data.data.activityRule
          if (!this.activityId) {
            alert('活动已下线，请关注后续最新活动')
          } else {
            this.registerUser()
          }
        } else {
          alert('活动已下线，请关注后续最新活动')
        }
      })
    },
    registerUser() {
      registerByOpenId(this.eno, this.wyAuthCode).then(res => {
        if (res.data && res.data.code !== "200") {
          alert(res.data.message || '注册失败')
        } else if (res.data && res.data.data) {
          this.token = res.data.data.token
          this.joinActivity()
        }
      }).catch(err => {
        console.error('注册用户失败:', err)
      })
    },
    async joinActivity() {
      try {
        const data = {
          code: this.code,
          activityId: this.activityId,
          authCode: this.wyAuthCode,
          userToken: this.token
        }
        const result = await joinActivity(data)
        if (result.data.code === "200") {
          this.showSuccess = true
          this.points = result.data.data.giftValue
        } else if (result.data.code === "500001") {
          this.isPointsClaimed = true
        } else {
          alert(result.data.message || '参与活动失败，请联系客服处理')
        }
      } catch (error) {
        console.error('参与活动失败:', error)
        alert("参与活动失败，请联系客服处理")
      }
    }
  }
}
</script>

<style scoped>
.cyq-activity {
  width: 100vw;
  min-height: 100vh;
  background: white;
  position: relative;
}

.lqjf-container {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 100vw;
  height: auto;
  z-index: 1;
}

.lqjf-img {
  width: 100%;
  height: auto;
  position: relative;
  z-index: 1;
}

.congrats-text {
  position: absolute;
  top: 30%;
  left: 50%;
  transform: translateX(-50%);
  z-index: 2;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.congrats-title {
  font-size: 6vw;
  font-weight: bold;
  color: rgb(93, 21, 0);
}

.congrats-points {
  font-size: 10vw;
  font-weight: bold;
  color: rgb(93, 21, 0);
}

.points-claimed {
  position: absolute;
  top: 37%;
  left: 50%;
  transform: translateX(-50%);
  font-size: 8vw;
  font-weight: bold;
  color: rgb(93, 21, 0);
  z-index: 2;
}

.qwsc-img {
  position: absolute;
  top: 71%;
  left: 50%;
  transform: translateX(-50%);
  width: 55vw;
  height: auto;
  z-index: 2;
}

.bg-img {
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100vw;
  height: auto;
  z-index: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/Cyq/Activity.vue